export default class Recurso {
  constructor(recurso = '', descricao = '') {
    this.recurso = recurso;
    this.descricao = descricao;
  }
}